<template>
  <div>
    <div class="row">
      <div class="col">
        <div style="padding-bottom: 10px">
          <el-button size="small" type="primary" @click="newServiceCenter"><i class="fa-solid fa-car"></i> Yeni
            müqavilə</el-button>
        </div>
      </div>
      <div class="col-md-4 col-12 ml-auto">
        <el-input size="small" :placeholder="$t('Axtar')" v-model="search"></el-input>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="data.filter(data => !search || 
                           data.name.toLowerCase().includes(search.toLowerCase()) || 
                           data.bankName.toLowerCase().includes(search.toLowerCase()))" style="width: 100%"
          class="compact-table">

          <el-table-column :label="$t('Təmir_mərkəzi')" width="300">
            <template slot-scope="scope">
              <div class="table-cell">
                <span class="bold-header">{{ scope.row.name }}</span>
                <span class="compact-text">TIN : {{ scope.row.serviceTin }}</span>
                <span class="compact-text">{{ $t('Hesab_#') }} : {{ scope.row.accountNumber }}</span>
                <span class="compact-text">{{ $t('Müqavilə_#') }} : {{ scope.row.contractNumber }}</span>
                <span class="compact-text">
                  Status : <status-label
                    :type="scope.row.active === 1 && scope.row.contractStatus === 1 ? 'green' : 'red'" />
                  {{ scope.row.activeName }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Bank')" width="400">
            <template slot-scope="scope">
              <div class="table-cell">
                <span class="bold-header">{{ scope.row.bankName }}</span>
                <span class="compact-text">TIN : {{ scope.row.tin }}</span>
                <span class="compact-text">{{ $t('Hesab_#') }} : {{ scope.row.cbAccount }}</span>
                <span class="compact-text">Swift : {{ scope.row.swift }}</span>
                <span class="compact-text">Kod : {{ scope.row.code }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs')" width="300">
            <template slot-scope="scope">
              <div class="table-cell">
                <span class="compact-text">{{ scope.row.contractPerson }}</span>
                <span class="compact-text">{{ scope.row.contractPhone }}</span>
                <span class="compact-text">{{ scope.row.email }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Müqavilə_müddət')" width="150">
            <template slot-scope="scope">
              <div class="table-cell">
                <span class="compact-text">{{ scope.row.startDateStr }}</span>
                <span class="compact-text">{{ scope.row.endDateStr }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Qeyd')" prop="notes">
            <template slot-scope="scope">
              <span class="compact-text">{{ scope.row.notes }}</span>
            </template>
          </el-table-column>

          <el-table-column align="right" fixed="right" width="50">
            <template slot="header"></template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                  <div class="square-icon">
                    <i class="fas fa-ellipsis-h" :title="$t('Əməliyyatlar')" style="color: #808080;"></i>
                  </div>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'edit', row: scope.row }">
                    <i class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}
                  </el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'delete', row: scope.row }">
                    <i class="fa-solid fa-trash-can"></i>{{$t('Ləğv_et')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <service-center ref="service" @saved="saved" />
  </div>
</template>

<script>
  import {
    GetAllServiceCenters,
    DeleteServiceCenter,
  } from "src/services/cls";
  import ServiceCenter from "./ServiceCenter.vue";
  import StatusLabel from "../components/StatusLabel.vue";
  export default {
    components: {
      ServiceCenter,
      StatusLabel
    },
    data() {
      return {
        mydata: false,
        loading: false,
        data: [],
        search: "",
        uid: this.$store.state.user.id,
      };
    },
    methods: {
      newServiceCenter() {
        this.$refs["service"].new();
      },
      saved() {
        this.getData();
      },
      handleCommand(command) {
        let id = command.row.id;
        if (command.action === "edit") this.handleEdit(id);
        else if (command.action === "delete") this.handleDelete(id);
      },
      handleEdit(id) {
        this.$refs["service"].edit(id);
      },
      handleDelete(id) {
        this.$confirm(this.$t('Təmir_mərkəzi_ləğv_olunsun'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteServiceCenter(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0]
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Ləğv_olundu'),
                  });
                  this.getData();
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Xəta_Serverdən_cavab_alınmadı'),
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
      getData() {
        this.loading = true;
        GetAllServiceCenters().then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
          }
        });
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .compact-table {
     font-size: var(--font-primary);
  }

  .compact-table ::v-deep .el-table__row td {
    padding: 4px 0;
  }

  .bold-header {
    font-size: var(--font-primary);
    font-weight: bold;
    display: block;
    margin-bottom: 4px;
  }

  .compact-text {
     font-size: var(--font-medium);
    display: block;
    margin: 3px 0;
    line-height: 1.3;
  }

  .table-cell {
    padding: 2px 0;
  }

  .custom-button {
    padding: 0 !important;
  }
</style>